

<app-loader [show]="skeleton"></app-loader>
<div [class.d-none]="skeleton">
  <div class="row">
  <div class="col-md-3 bg-white rounded">
    <div class="pl-3 pr-5">
      <app-navbar [step]="6">
      </app-navbar>
    </div>
  </div>
  <div class="col-md-9">
    <form [formGroup]="transferRequestForm" (ngSubmit)="save()">
      <input type="hidden" formControlName="id">
      <input type="hidden" formControlName="financialYearId">
      <input type="hidden" formControlName="phaseId">
      <input type="hidden" formControlName="profileId">
      <input type="hidden" formControlName="isHardStation">
      <input type="hidden" formControlName="isTransfer">
    <app-breadcrumb [title]="'Priority Category Details'"></app-breadcrumb>
    <app-employee-view *ngIf="profile" [showProfile]="false" [moreProfile]="false" [showPreference]="false" [profile]="profile"></app-employee-view>
  <div class="d-flex">
      <div class="d-flex justify-content-center mb-3">
        <a [routerLink]="['/employee/service-book']" class="btn btn-primary rounded-0">PREVIOUS</a>
      </div>
      <!-- <button type="submit" class="btn btn-primary rounded-0 ml-auto mr-2 mb-3" [routerLink]="['/employee/transfer-request']">NEXT </button> -->
      <button class="btn btn-primary rounded-0 ml-auto mr-2 mb-3" [disabled]="!transferRequestForm.valid || loading"
        type="submit">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
        Submit
      </button>
  </div>
</form>
</div>
</div>
</div>
